import {OpenMapTilesLanguage} from "@teritorio/openmaptiles-gl-language/src/index"

type Options = {
    supportedLanguages: string[]; // List of supported languages
    languageField?: RegExp; // /^name:/ // RegExp to match if a text-field is a language field
    getLanguageField?: Function; // Given a language choose the field in the vector tiles
    languageSource?: string; // Name of the source that contains the different languages.
    defaultLanguage?: string; // Name of the default language to initialize style after loading.
    excludedLayerIds?: string[]; // Name of the layers that should be excluded from translation.
}

export class LanguageControl {
    protected _map?: maplibregl.Map;
    protected _container?: HTMLDivElement;
    private _initialUpdateBind: () => void;
    private _language: OpenMapTilesLanguage;
    private _options: Options;

    constructor(options?: Options) {
        this._initialUpdateBind = this._initialUpdate.bind(this);
        this._options = options
        // @ts-ignore
        this._language = new OpenMapTilesLanguage(options);
    }

    onAdd(map: maplibregl.Map) {
        this._map = map;
        this._map.on('styledata', this._initialUpdateBind);
        this._container = document.createElement('div');
        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map?.off('styledata', this._initialUpdateBind);
        this._map = undefined;
        this._language = undefined;
    }

    protected _initialUpdate() {
        const language = this._options?.defaultLanguage || this._language.browserLanguage(this._options?.supportedLanguages);

        this._map?.off('styledata', this._initialUpdateBind);
        this._language.setLanguage(language);
    }
}
